import React from "react";
import { Row, Col, Form, Input, Select } from "antd"; // Import Select from Ant Design
import classes from "../Pages.module.css";

const { Option } = Select; // Destructure Option from Select

const FormRenderer = (props) => {
  const handleSelectChange = (value, param, dataKey) => {
    const selectedOption = props.ad?.[dataKey]?.rows?.find(
      (option) => option[props.ad[dataKey].fields[0].name] === value
    );

    props.setData((data) => {
      const newdata = [...data["accountHeader"]];
      newdata[0][param] = value;
      newdata[0][`${param}_name`] = selectedOption
        ? selectedOption[props.ad[dataKey].fields[1].name] // Assuming field[1] is the name field
        : "";
      return {
        ...data,
        accountHeader: newdata,
      };
    });
  };

  return (
    <Row className={classes["RowDE"]}>
      {/* Purpose Field */}
      <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div style={{ padding: "0rem 0.5rem", fontSize: "0.7rem", fontWeight: "bold" }}>
                Purpose  <span style={{color:"red" , marginLeft:"1px"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter Description"
              value={props.data.pursose || ""}
              onChange={(e) => props.setData((data) => ({
                ...data,
                accountHeader: [{ ...data.accountHeader[0], pursose: e.target.value }]
              }))}
              bordered={false}
              style={{
                width: "100%",
                backgroundColor: "white",
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>


   {/* Department Select Field */}
   <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div style={{ padding: "0rem 0.5rem", fontSize: "0.7rem", fontWeight: "bold" }}>
                Department  <span style={{color:"red" , marginLeft:"1px"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Select
              placeholder="Select Department"
              value={props.data?.department_code || ""}
              onChange={(value) => handleSelectChange(value, "department_code", "department")}
              style={{ width: "100%" }}
              disabled={!props.ad?.department?.rows}
            >
              {props.ad?.department?.rows?.map((option) => (
                <Option key={option[props.ad.department.fields[0].name]} value={option[props.ad.department.fields[0].name]}>
                  {option[props.ad.department.fields[1].name]}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Col>


      {/* Designation Select Field */}
      <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div style={{ padding: "0rem 0.5rem", fontSize: "0.7rem", fontWeight: "bold" }}>
                Designation
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Select
              placeholder="Select Designation"
              value={props.data?.designation_code || ""}
              onChange={(value) => handleSelectChange(value, "designation_code", "designation")}
              style={{ width: "100%" }}
              disabled={!props.ad?.designation?.rows}
            >
              {props.ad?.designation?.rows?.map((option) => (
                <Option key={option[props.ad.designation.fields[0].name]} value={option[props.ad.designation.fields[0].name]}>
                  {option[props.ad.designation.fields[1].name]}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Col>

         {/* Team Name Field */}
         <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div style={{ padding: "0rem 0.5rem", fontSize: "0.7rem", fontWeight: "bold" }}>
                Team Name  <span style={{color:"red" , marginLeft:"1px"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter Description"
              value={props.data.team_name || ""}
              onChange={(e) => props.setData((data) => ({
                ...data,
                accountHeader: [{ ...data.accountHeader[0], team_name: e.target.value }]
              }))}
              bordered={false}
              style={{
                width: "100%",
                backgroundColor: "white",
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>

      {/* Leader Select Field */}
      <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div style={{ padding: "0rem 0.5rem", fontSize: "0.7rem", fontWeight: "bold" }}>
                Leader  <span style={{color:"red" , marginLeft:"1px"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Select
              placeholder="Select Leader"
              value={props.data?.leader_code || ""}
              onChange={(value) => handleSelectChange(value, "leader_code", "leader")}
              style={{ width: "100%" }}
              disabled={!props.ad?.leader?.rows}
            >
              {props.ad?.leader?.rows?.map((option) => (
                <Option key={option[props.ad.leader.fields[0].name]} value={option[props.ad.leader.fields[0].name]}>
                  {option[props.ad.leader.fields[1].name]}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Col>

      {/* Submit Button */}
      <Col span={8} style={{ margin: "auto" }}>
        {props.save ? (
          <button onClick={(event) => props.handleSubmit(event)} className={classes["ProfileButtonF"]}>
            Add Record
          </button>
        ) : null}
      </Col>
    </Row>
  );
};

export default FormRenderer;
